import { useState, useEffect } from "react";
import { API_URL } from "../config/env";
import { styles } from "../styles/appStyles";
import { track } from "../lib/analytics";

export default function SuccessPage() {
  const [status, setStatus] = useState("loading");

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const sessionId = params.get("session_id");
    if (!sessionId) { setStatus("error"); return; }

    fetch(`${API_URL}/verify-session?session_id=${sessionId}`)
      .then(r => r.json())
      .then(data => {
        if (data.success) {
          track("subscription_activated", { plan: data.plan });
          setStatus("success");
          setTimeout(() => {
            window.location.href = `/?session_id=${sessionId}&payment=success`;
          }, 2000);
        } else {
          setStatus("error");
        }
      })
      .catch(() => setStatus("error"));
  }, []);

  return (
    <>
      <style>{styles}</style>
      <div className="success-page">
        {status === "loading" && (
          <>
            <div className="success-icon">...</div>
            <div className="success-title">Verifying your subscription...</div>
          </>
        )}
        {status === "success" && (
          <>
            <div className="success-icon">✓</div>
            <div className="success-title">Welcome to Pitcherly!</div>
            <div className="success-sub">Your subscription is active. Redirecting...</div>
          </>
        )}
        {status === "error" && (
          <>
            <div className="success-icon">✗</div>
            <div className="success-title">Something went wrong</div>
            <div className="success-sub">Please try again or contact support.</div>
          </>
        )}
      </div>
    </>
  );
}
